import { Chart as ChartJS, ArcElement } from 'chart.js';
import { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

ChartJS.register(ArcElement);

const EmptyChartCountry = () => {
  const { isCompareMode } = useSelector((state) => ({
    isCompareMode: state.filters.isCompareMode
  }));
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const legendOnRight = isCompareMode && screenWidth > 991;

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: { right: legendOnRight ? 100 : 0 }
    },
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false }
    }
  };

  const data = {
    datasets: [
      {
        data: [3, 3, 10, 18, 26, 40],
        backgroundColor: [
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4'
        ],
        borderColor: '#FFFFFF',
        borderWidth: 1
      }
    ]
  };

  return (
    <PieWrapper isCompareMode={isCompareMode} className="mx-auto w-100">
      <Pie data={data} options={options} />
    </PieWrapper>
  );
};

export default EmptyChartCountry;

const PieWrapper = styled.div`
  aspect-ratio: 1 / 1;
  max-width: ${(props) => (props.isCompareMode ? 450 : 450)}px;
`;
